import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import Components from "slotworks/components/components";
import gameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import smartUiFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";

export default function updateFieldsAfterFreespins() {
    const gameplay = gameState.getCurrentGame();

    smartUiFlags.set(SmartUIFlag.FREE_SPINS, false);
    smartUiFlags.set(SmartUIFlag.PROMPT, false);

    Services.transaction.setBalance(gameState.getCurrentGame().balance);
    Services.transaction.setWinnings(gameplay.getTotalWin()).execute();

    Components.betBar.setType(BetBarType.DEFAULT);
}
